import { apiDelete, apiGet, apiPost, apiPut, apiUpload } from './http'

function buildQuery(params = {}) {
  const sp = new URLSearchParams()
  Object.keys(params).forEach(k => {
    const v = params[k]
    if (v === undefined || v === null || v === '') return
    sp.append(k, v)
  })
  const qs = sp.toString()
  return qs ? `?${qs}` : ''
}


// 登录
export function login(payload) {
  return apiPost('/api/auth/login', payload)
}

// 录入页：创建订单 + 游客
export function createOrder(payload) {
  return apiPost('/api/orders', payload)
}

// 检查订单号是否已存在
export function checkOrderNo(orderNo) {
  return apiGet('/api/orders/check-order-no', { orderNo })
}

// 游客信息表
export function getVisitors(params) {
  return apiGet('/api/visitors', params)
}

export function deleteVisitor(visitorId) {
  return apiDelete(`/api/visitors/${visitorId}`)
}

export function clearVisitors(filters = {}) {
  return apiPost('/api/visitors/clear', { confirm: true, ...filters })
}

// 导入游客数据（Excel/CSV），上传 FormData（字段名 file）
export function importVisitors(formData) {
  return apiUpload('/api/visitors/import', formData)
}

// 核销
export function getVerifications(params) {
  return apiGet('/api/verifications', params)
}

export function verifyVisitor(visitorId, remark) {
  return apiPost(`/api/verifications/${visitorId}/verify`, { remark })
}

// 取消核销
export function cancelVerification(visitorId) {
  return apiDelete(`/api/verifications/${visitorId}`)
}

// 更新核销备注（不改变核销状态）
export function updateVerificationRemark(visitorId, remark) {
  return apiPost(`/api/verifications/${visitorId}/remark`, { remark })
}

export function clearVerifications() {
  return apiPost('/api/verifications/clear', { confirm: true })
}

// 财务
export function getFinance(params) {
  return apiGet('/api/finance', params)
}

export function updateFinance(visitorId, payload) {
  return apiPut(`/api/finance/${visitorId}`, payload)
}

export function deleteFinance(visitorId) {
  return apiDelete(`/api/finance/${visitorId}`)
}

export function clearFinance() {
  return apiPost('/api/finance/clear', { confirm: true })
}

// 财务导入（CSV 文件上传）
export function batchUpdateFinancePrice(payload, params) {
  // params: finance filters (platform/ticketType/area/visitDate/talent)
  return apiPost('/api/finance/batch-update-price' + buildQuery(params || {}), payload)
}

export function batchUpdateFinanceTalent(payload, params) {
  return apiPost('/api/finance/batch-update-talent' + buildQuery(params || {}), payload)
}

export function importFinance() {
  // importFinance 已删除（功能已从前端移除）
  return Promise.reject(new Error('importFinance disabled'))
}

// 获取导入记录（finance_imports） - 前端当前隐藏该功能，保留接口调用以备将来使用
export function getFinanceImports(params) {
  return apiGet('/api/finance/imports', params)
}

// 大屏
export function getDashboardSummary(params) {
  return apiGet('/api/dashboard/summary', params)
}

// 获取平台统计（用于大屏的观礼平台分析）
export function getPlatformCounts(params) {
  return apiGet('/api/dashboard/platformCounts', params)
}

// 获取平台对应的票种及数量（用于大屏票种分布）
export function getPlatformTicketTypes() {
  return apiGet('/api/platform-ticket-types')
}

// 获取游客渠道选项（单独接口）
export function getChannelOptions() {
  return apiGet('/api/settings/visitor/channel-options')
}

// 获取渠道统计（大屏专用）：raw + canonical
export function getChannelCounts(params) {
  return apiGet('/api/dashboard/channelCounts', params)
}

// 获取人口统计（大屏专用）
export function getDemographicCounts(params) {
  return apiGet('/api/dashboard/demographicCounts', params)
}

// 获取财务摘要（大屏专用）
export function getFinanceSummary(params) {
  return apiGet('/api/dashboard/financeSummary', params)
}

// 获取达人 vs 非达人对比（大屏专用）
export function getTalentCompare(params) {
  return apiGet('/api/dashboard/talentCompare', params)
}

// 获取核销趋势（大屏专用）
export function getVerifyTrend(params) {
  return apiGet('/api/dashboard/verifyTrend', params)
}

// 账户
export function changePassword(payload) {
  return apiPost('/api/account/change-password', payload)
}

// 系统设置：管理员（仅超级管理员可用）
export function getAdmins() {
  return apiGet('/api/admin/users')
}

export function createAdmin(payload) {
  return apiPost('/api/admin/users', payload)
}

export function resetAdminPassword(id, newPassword) {
  // Use alternative endpoint that accepts JSON body { id, newPassword }
  return apiPost('/api/admin/reset-password', { id, newPassword })
}

export function deleteAdmin(id) {
  return apiDelete(`/api/admin/users/${id}`)
}

// 系统设置：系统信息/备份
export function getSystemStats() {
  return apiGet('/api/system/stats')
}

export function backupDatabase() {
  return apiPost('/api/system/backup', {})
}

// detect mysqldump on server
export function detectMysqldump() {
  return apiGet('/api/system/mysqldump-detect')
}

// restore database from uploaded .sql file (formData with field 'file')
export function restoreDatabase(formData) {
  return apiUpload('/api/system/backup/restore', formData)
}

// 系统设置：获取设置
export function getSettings() {
  return apiGet('/api/settings')
}

// 系统设置：保存游客配置
export function saveVisitorSettings(payload) {
  console.log('API saveVisitorSettings payload:', payload)
  return apiPut('/api/settings/visitor', payload)
}

